import { Component, OnInit, Inject, ElementRef } from '@angular/core';
import { CabinetsService } from '../../../../cabinets/data/cabinets.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Material } from 'projects/desktop/src/app/modules/vendor/data/material';
import { Cabinet } from '../../../../cabinets/data/cabinet';
import { ShortObject } from '../../../data/project/short-json-object';
import { SelectItem } from 'primeng/api';
import { timer } from 'rxjs';

@Component({
    selector: 'app-labels-print-dialog',
    templateUrl: './labels-print-dialog.component.html',
    styleUrls: ['./labels-print-dialog.component.scss']
})
export class LabelsPrintDialogComponent implements OnInit {
    scanLoading: boolean;
    loadingSpinner: boolean;

    projectId: number;
    projectName: string;

    projectCabs: Cabinet[];
    selectedCabs: Cabinet[] = [];

    showCabs: boolean;

    cities2: ShortObject[];
    selectedCity2: ShortObject;

    constructor(
        protected cabinetsService: CabinetsService,
        protected el: ElementRef,
        @Inject(MAT_DIALOG_DATA) public data: { id: number, name: string },
        protected dialogRef: MatDialogRef<LabelsPrintDialogComponent>
    ) {
        this.projectId = data.id;
        this.projectName = data.name;
    }

    ngOnInit(): void {
        this.getCabinets();
    }

    getCabinets() {
        this.showCabs = false;
        this.cabinetsService.getCabinets(this.projectId).subscribe(cabs => {
            this.projectCabs = cabs.map(cab => {
                const tempCab = Object.assign({}, cab)
                tempCab.showName = `#${cab.cabinetId} - ${cab.cabinetName}`
                return tempCab;
            });

            this.selectedCabs = [...this.projectCabs]
            this.showCabs = true;
            this.dropDownIsShown();
        })
    }

    dropDownIsShown() {
        const elems = (this.el.nativeElement as HTMLElement).getElementsByClassName('p-list-box-block');
        const allProjects = [...this.projectCabs];

        timer(1).subscribe(emit => {
            const inputs = elems[0].getElementsByClassName('p-inputtext')

            inputs[0].addEventListener('keyup', eventtt => {
                const val = (inputs[0] as HTMLInputElement).value.toLowerCase();
                if (val) {
                    this.projectCabs = allProjects.filter(cab => {
                        const name = cab.cabinetName.toLowerCase();
                        return name.includes(val)
                    });
                }
                else {
                    this.projectCabs = allProjects
                }

            });
        })
    }


    printLabels() {
        this.loadingSpinner = true;
        if (this.projectCabs.length === this.selectedCabs.length) {
            this.printAllLabels();
        }
        else {
            const cabsIds = this.selectedCabs.map(cab => cab.id).join(',')
            this.cabinetsService.printSelectedLabels(this.projectId, cabsIds).subscribe(emit => {
                this.dialogRef.close('Success!');
            }, error => {
                this.loadingSpinner = false;
            })
        }
    }

    printAllLabels() {

        this.cabinetsService.printLabels(this.projectId).subscribe(done => {
            this.dialogRef.close('Success!');
        }, error => {
            this.loadingSpinner = false;
        })
    }

    closeDialog() {
        this.dialogRef.close('close-button');
    }

}
